import React from 'react';
import { generatePath } from 'react-router';

import { isRenderingFileCompositorReady } from 'src/modules/renderings/components/RenderingsHub/InteractiveRenderingsLink/InteractiveRenderingsLink';
import { BaseCTAButton } from 'src/modules/renderings/components/RenderingsHub/RenderingsList/BaseCTAButton';
import { useRenderingSelection } from 'src/modules/renderings/hooks/useRenderingSelection/useRenderingSelection';
import { Link } from 'src/shared/components';
import {
  TranslationNamespace,
  useReactNativeWebView,
  useTranslate,
} from 'src/shared/hooks';
import { Route } from 'src/shared/route';

export const INTERACTIVE_RENDERING_LINK_CTA = 'interactive-rendering-cta-link';

/**
 * A link to interactive renderings styled as a button sized appropriately for placement above the renderings list
 */
export const InteractiveRenderingsCTA = () => {
  const { rendering, renderingFile } = useRenderingSelection();
  const [isWebView] = useReactNativeWebView();
  const t = useTranslate(TranslationNamespace.SHARED);

  if (!rendering || !renderingFile) {
    return null;
  }

  if (!isRenderingFileCompositorReady(renderingFile)) {
    return null;
  }

  const path = generatePath(Route.RENDERINGS_INTERACTIVE.path, {
    renderingId: rendering.id,
    renderingFileId: renderingFile.id,
  });

  // isExternal is used to open the link in a new tab, the link does not actually point to an external resource
  return (
    <Link
      isExternal={!isWebView}
      isMinimal
      testId={INTERACTIVE_RENDERING_LINK_CTA}
      to={path}
      width="100%"
    >
      <BaseCTAButton>{t('renderings.interactive.linkFromHub')}</BaseCTAButton>
    </Link>
  );
};
